import {Component, ElementRef, Input} from '@angular/core';

@Component({
    selector: 'loading',
    templateUrl: 'loading.html',
    providers: []
})
export class Loading {

    @Input('image') image: string;
    @Input('texto') texto: string;
    @Input('imgcor') imgcor: string;
    @Input('background') background: string;

    config: any;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/components/loading/loading.ts